import { render, staticRenderFns } from "./Recursive.vue?vue&type=template&id=74d796e2&scoped=true&"
import script from "./Recursive.vue?vue&type=script&lang=ts&"
export * from "./Recursive.vue?vue&type=script&lang=ts&"
import style0 from "./Recursive.vue?vue&type=style&index=0&id=74d796e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d796e2",
  null
  
)

export default component.exports